/**
 * Type guard to check if an event has a relatedTarget property.
 */
function hasRelatedTarget(event: Event): event is Event & { relatedTarget: EventTarget | null } {
	return 'relatedTarget' in event;
}

/**
 * Checks if the mouse is moving to an atlaskit portal or kudos modal
 * where we should prevent the popup from closing
 */
function isMovingToKudos(relatedTarget: EventTarget | null) {
	if (!(relatedTarget instanceof HTMLElement)) {
		return false;
	}

	const iframe =
		relatedTarget.closest('.atlaskit-portal')?.querySelector('iframe') ||
		relatedTarget.closest('iframe');
	return iframe instanceof HTMLIFrameElement && iframe.src.includes('give-kudos');
}

/**
 * Returns the child portal if mouse is moving to a portal controlled by the parent popup.
 */
function getChildPortalFromParentPopup(
	relatedTarget: EventTarget | null,
	parentPopupElement: HTMLElement | null,
): Element | null {
	if (!(relatedTarget instanceof HTMLElement) || !parentPopupElement) {
		return null;
	}

	const portal = relatedTarget.closest('.atlaskit-portal');
	if (!portal) {
		return null;
	}

	// Portal controlled by parent popup trigger (e.g. actions menu)
	for (const trigger of parentPopupElement.querySelectorAll('[aria-controls]')) {
		const controlsId = trigger.getAttribute('aria-controls');
		if (controlsId && portal.querySelector(`#${controlsId}`)) {
			return portal;
		}
	}

	return null;
}

export { hasRelatedTarget, isMovingToKudos, getChildPortalFromParentPopup };
